"use client"; 
import { Link } from 'react-router-dom';
import React, { useState } from 'react';

const ScheduleOne = () => {
    const [activeTab, setActiveTab] = useState('step-1');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <section id="th-event" className="schedule-one">
            <div className="container">
                <div className="schedule-one__inner">
                    <div className="section-title text-left">
                        <div className="section-title__tagline-box">
                            <span className="section-title__tagline">How It Works</span>
                        </div>
                        <h2 className="section-title__title">Your Order in 4 Simple Steps</h2>
                    </div>
                    <div className="schedule-one__main-tab-box tabs-box">
                        <ul className="tab-buttons clearfix list-unstyled">
                            <li
                                className={`tab-btn ${activeTab === 'step-1' ? 'active-btn' : ''}`}
                                onClick={() => handleTabClick('step-1')}
                            >
                                <h3>Step 1</h3>
                                <p>Free Consultation</p>
                            </li>
                            <li
                                className={`tab-btn ${activeTab === 'step-2' ? 'active-btn' : ''}`}
                                onClick={() => handleTabClick('step-2')}
                            >
                                <h3>Step 2</h3>
                                <p>Design & Approval</p>
                            </li>
                            <li
                                className={`tab-btn ${activeTab === 'step-3' ? 'active-btn' : ''}`}
                                onClick={() => handleTabClick('step-3')}
                            >
                                <h3>Step 3</h3>
                                <p>Quality Production</p>
                            </li>
                            <li
                                className={`tab-btn ${activeTab === 'step-4' ? 'active-btn' : ''}`}
                                onClick={() => handleTabClick('step-4')}
                            >
                                <h3>Step 4</h3>
                                <p>On-Time Delivery</p>
                            </li>
                        </ul>
                        <div className="tabs-content">
                            <div className={`tab ${activeTab === 'step-1' ? 'active-tab' : ''}`} id="step-1">
                                <div className="schedule-one__tab-content-box">
                                    <div className="schedule-one__single">
                                        <div className="schedule-one__left">
                                        <h3 className="schedule-one__title">
                                            <Link to="/contact">
                                            Free Consultation
                                            </Link>
                                        </h3>
                                        <p className="schedule-one__text">
                                            Share your vision and goals. We'll recommend products <br /> 
                                            that fit your needs and budget.
                                        </p>
                                        </div>
                                        <div className="schedule-one__address-and-btn-box">
                                        <ul className="list-unstyled schedule-one__address">
                                            <li>
                                            <div className="icon">
                                                <span className="icon-clock"></span>
                                            </div>
                                            <div className="text">
                                                <p>
                                                Quick Response <br /> Within 24 Hours
                                                </p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>
                                                Call or Email <br /> <a href="tel:8007215822" style={{color: 'inherit', textDecoration: 'none'}}>800-721-5822</a>
                                                </p>
                                            </div>
                                            </li>
                                        </ul>
                                        <div className="schedule-one__btn-box">
                                            <Link to="/contact" className="schedule-one__btn thm-btn">
                                            Get Started
                                            <span className="icon-arrow-right"></span>
                                            </Link>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`tab ${activeTab === 'step-2' ? 'active-tab' : ''}`} id="step-2">
                                <div className="schedule-one__tab-content-box">
                                    <div className="schedule-one__single">
                                        <div className="schedule-one__left">
                                        <h3 className="schedule-one__title">
                                            <Link to="/contact">
                                            Design & Approval
                                            </Link>
                                        </h3>
                                        <p className="schedule-one__text">
                                            Our team creates mockups for your review. <br /> We refine until you're 100% satisfied.
                                        </p>
                                        </div>
                                        <div className="schedule-one__address-and-btn-box">
                                        <ul className="list-unstyled schedule-one__address">
                                            <li>
                                            <div className="icon">
                                                <span className="icon-clock"></span>
                                            </div>
                                            <div className="text">
                                                <p>
                                                Free Revisions <br /> Until Approved
                                                </p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>
                                                Digital Proofs <br /> Before Production
                                                </p>
                                            </div>
                                            </li>
                                        </ul>
                                        <div className="schedule-one__btn-box">
                                            <Link to="/contact" className="schedule-one__btn thm-btn">
                                            Get Started <span className="icon-arrow-right"></span>
                                            </Link>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`tab ${activeTab === 'step-3' ? 'active-tab' : ''}`} id="step-3">
                                <div className="schedule-one__tab-content-box">
                                    <div className="schedule-one__single">
                                        <div className="schedule-one__left">
                                        <h3 className="schedule-one__title">
                                            <Link to="/contact">
                                            Quality Production
                                            </Link>
                                        </h3>
                                        <p className="schedule-one__text">
                                            Your order goes into production with careful <br /> attention to every detail.
                                        </p>
                                        </div>
                                        <div className="schedule-one__address-and-btn-box">
                                        <ul className="list-unstyled schedule-one__address">
                                            <li>
                                            <div className="icon">
                                                <span className="icon-clock"></span>
                                            </div>
                                            <div className="text">
                                                <p>Quality Control <br /> At Every Step</p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>Status Updates <br /> Throughout Process</p>
                                            </div>
                                            </li>
                                        </ul>
                                        <div className="schedule-one__btn-box">
                                            <Link to="/contact" className="schedule-one__btn thm-btn">
                                                Get Started <span className="icon-arrow-right"></span>
                                            </Link>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`tab ${activeTab === 'step-4' ? 'active-tab' : ''}`} id="step-4">
                                <div className="schedule-one__tab-content-box">
                                    <div className="schedule-one__single">
                                        <div className="schedule-one__left">
                                        <h3 className="schedule-one__title">
                                            <Link to="/contact">
                                            On-Time Delivery
                                            </Link>
                                        </h3>
                                        <p className="schedule-one__text">
                                            Receive your custom merchandise exactly <br /> when you need it, guaranteed.
                                        </p>
                                        </div>
                                        <div className="schedule-one__address-and-btn-box">
                                        <ul className="list-unstyled schedule-one__address">
                                            <li>
                                            <div className="icon">
                                                <span className="icon-clock"></span>
                                            </div>
                                            <div className="text">
                                                <p>On-Time Guarantee <br /> Or It's Free</p>
                                            </div>
                                            </li>
                                            <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>Nationwide Shipping <br /> Direct to You</p>
                                            </div>
                                            </li>
                                        </ul>
                                        <div className="schedule-one__btn-box">
                                            <Link to="/contact" className="schedule-one__btn thm-btn">
                                                Get Started <span className="icon-arrow-right"></span>
                                            </Link>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ScheduleOne;
